export const getFirstName = (fullName?: string) => fullName?.trim().split(' ')[0] || undefined;
